import { CSSProperties, ReactNode } from "react";
import { Theme } from "../../config/themes";
import classNames, { Argument } from "classnames";
import { useSiteFeatures } from "../../hooks/useSiteFeatures";
import EnterViewportAnimation from "../EnterViewportAnimation";
import "./style.scss";

interface ContentSectionProps {
  id?: string;
  style?: CSSProperties;
  containerStyle?: CSSProperties;
  className?: Argument;
  requiresFeature?: string;
  theme?: Theme;
  containerTheme?: Theme;
  containerClassName?: Argument;
  padded?: boolean;
  sidePadded?: boolean;
  fadeIn?: boolean;
  noMargins?: boolean;
  fullWidth?: boolean;
  navTitle?: string;
  children: ReactNode;
}

const ContentSection = ({
  id,
  style = {},
  containerStyle,
  className,
  theme = "white",
  requiresFeature,
  containerTheme,
  containerClassName,
  padded,
  sidePadded,
  noMargins,
  fullWidth,
  navTitle: _navTitle,
  fadeIn,
  children,
  ...unhandledProps
}: ContentSectionProps) => {
  const classes = classNames(
    "content-section",
    className,
    "theme-" + theme,
    padded ? "content-section-padded" : "",
    sidePadded ? "content-section-side-padded" : "",
    noMargins ? "content-section-no-margins" : "",
    fullWidth ? "content-section-full-width" : ""
  );
  const containerClasses = classNames(
    "content-section-container",
    containerTheme ? "theme-" + containerTheme : "",
    containerClassName
  );
  const features = useSiteFeatures();
  return !requiresFeature || features.hasFeature(requiresFeature) ? (
    <div id={id} style={style} className={classes} {...unhandledProps}>
      <div className={containerClasses} style={containerStyle}>
        {fadeIn ? (
          <EnterViewportAnimation mode="fade-up">
            {children}
          </EnterViewportAnimation>
        ) : (
          children
        )}
      </div>
    </div>
  ) : null;
};

export default ContentSection;
